import { CLEAR_XML } from './types'

export const clearXml = () => ({
  type: CLEAR_XML
})